module.exports = __webpack_public_path__ + "img/frame (69).7213bc0a.jpg";